import { useMe } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { useUpdateUserDetails } from '../data-access';

export const useChangeCurrency = () => {
	const { updateUserMeData } = useMe();

	const { isLoading: isUpdateUserDetailsLoading, mutateAsync: updateUserDetails } = useUpdateUserDetails();

	const onChangeCurrency = useCallback(
		async (currency: string) => {
			const resp = await updateUserDetails({ preferredFiatCurrencyCode: currency });

			updateUserMeData(resp);
		},
		[updateUserMeData, updateUserDetails]
	);

	return {
		isLoading: isUpdateUserDetailsLoading,
		onChangeCurrency
	};
};
